@if (selectedType$ | async; as type) {
	<div class="c-tabbar">
		<button class="c-tabbar__item" [class.c-tabbar__item--selected]="type === OffersType.DAYTRIP" (click)="select(OffersType.DAYTRIP)">{{ 'TABBAR.DAYTRIP' | translate }}</button>
		<button class="c-tabbar__item" [class.c-tabbar__item--selected]="type === OffersType.ACCOMMODATION" (click)="select(OffersType.ACCOMMODATION)">
			{{ 'TABBAR.ACCOMMODATION' | translate }}
		</button>
		<button class="c-tabbar__item" [class.c-tabbar__item--selected]="type === OffersType.ORGANIZED_HOLIDAY" (click)="select(OffersType.ORGANIZED_HOLIDAY)">
			{{ 'TABBAR.ORGANIZED_HOLIDAY' | translate }}
		</button>
	</div>
}
